export const CURRENT_VIEW = 'CURRENT_VIEW';
export const CLEAN_UP = 'CLEAN_UP';
export const SET_INITIAL_STATE_FOR_INCOME_EVENTS = 'SET_INITIAL_STATE_FOR_INCOME_EVENTS';
export const SET_INCOME_ACCOUNT_HOLDER_OPTIONS = 'SET_INCOME_ACCOUNT_HOLDER_OPTIONS';
export const SET_SELECTED_INCOME_EVENT = 'SET_SELECTED_INCOME_EVENT';
export const UPDATE_INCOME_EVENT_DATA = 'UPDATE_INCOME_EVENT_DATA';
export const UPDATE_SELECTED_INCOME_EVENT = 'UPDATE_SELECTED_INCOME_EVENT';
export const MODEL_INCOME_EVENTS_DATA = 'MODEL_INCOME_EVENTS_DATA';

export const setInitialStateForIncomeEvents = (data: any) => ({
    type: SET_INITIAL_STATE_FOR_INCOME_EVENTS,
    payload: data,
});
export const cleanup = () => ({
    type: CLEAN_UP,
  });

export const setCurrentView = (page: string) => ({
    type: CURRENT_VIEW,
    payload: page,
  });

export const modelIncomeEventsData = (event: any) => ({
    type: MODEL_INCOME_EVENTS_DATA,
    payload: event
});

export const setIncomeAccountHolderOptions = (data: any) => ({
    type: SET_INCOME_ACCOUNT_HOLDER_OPTIONS,
    payload: data,
});

export const setSelectedIncomeEvent = (event: any) => ({
    type: SET_SELECTED_INCOME_EVENT,
    payload: event,
});

export const updateSelectedIncomeEvent = (data: any) => ({
    type: UPDATE_SELECTED_INCOME_EVENT,
    payload: data,
});

export const updateIncomeEventData = (data: any) => ({
    type: UPDATE_INCOME_EVENT_DATA,
    payload: data,
});